<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Manage Users</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="display: flex; gap: 8px; align-items: center">
            <!--
      <nz-select [(ngModel)]="searchField" style="width: auto">
        <nz-option
          *ngFor="let field of searchFields"
          [nzValue]="field.value"
        [nzLabel]="field.label"></nz-option>
      </nz-select>
      -->
            <div class="control-label">User Name:</div>
            <input
                nz-input
                [(ngModel)]="searchValue"
                placeholder="Enter user name..."
                style="width: 200px"
                (keydown.enter)="onSearch()" />
            <button nz-button nzType="primary" (click)="onSearch()">Search</button>
            <button nz-button (click)="clearSearch()">Reset</button>
            <button nz-button nz-dropdown class="pull-right" aria-label="Export" (click)="onExport()">
                <nz-icon nzType="file-excel" nzTheme="fill" />Export
            </button>
        </div>
        <div style="margin-top: 10px; margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <nz-switch
                name="showDeleted"
                id="showDeleted"
                nzSize="small"
                [(ngModel)]="showDeleted"
                (ngModelChange)="onSearch()"
                [nzCheckedChildren]="checkedTmpl"
                [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
            Show Deleted Users
        </div>

        @if (!showDeleted) {
            <div style="margin-top: 10px; margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
                <button nz-button class="btn-success" [routerLink]="['/configure/usercreate']">New User</button>
            </div>
        }
        <nz-table
            #customerTable
            [nzData]="users.Data"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzShowTotal]="totalTemplate"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <!-- begin normal user search results -->
            @if (!showDeleted) {
                <thead style="border: 1px solid black">
                    <tr>
                        @for (column of columns; track column) {
                            @if (column.enabled) {
                                <th
                                    [nzShowSort]="column.compare"
                                    [nzSortFn]="column.compare"
                                    [nzColumnKey]="column.fieldName"
                                    [nz-tooltip]="column.title === '2FA' ? 'Two-Factor Authentication' : ''"
                                    [ngClass]="{'has-tooltip': column.title === '2FA'}"
                                    [nzWidth]="column.width !== null ? column.width : 'auto'"
                                    [nzSortOrder]="getSortOrder(column.fieldName)">
                                    {{ column.title }}
                                </th>
                            }
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (data of users.Data; track data.UserID) {
                        <tr>
                            <td class="scrollable-cell" style="text-align: center">{{ data.UserName }}</td>
                            <td class="scrollable-cell" style="text-align: center">{{ data.Email }}</td>
                            <td style="text-align: center">
                                @if (data.TwoFactorEnabled) {
                                    <span style="color: green" class="fa-solid fa-check"></span>
                                }
                            </td>
                            <td style="text-align: center">{{ data.Groups }}</td>
                            <td style="text-align: center">
                                @if (data.PerFormaAdmin) {
                                    <span style="color: green" class="fa-solid fa-check"></span>
                                }
                            </td>
                            @if (moduleIsEnabled("Scan")) {
                                <td style="text-align: center">
                                    @if (data.PerFormaScanAdmin) {
                                        <span style="color: green" class="fa-solid fa-check"></span>
                                    }
                                </td>
                            }
                            @if (moduleIsEnabled("APCheck")) {
                                <td style="text-align: center">
                                    @if (data.APCheckAdmin) {
                                        <span>Admin</span>
                                    }
                                    @if (data.APCheckUser) {
                                        <span>User</span>
                                    }
                                </td>
                            }
                            @if (moduleIsEnabled("ARReport")) {
                                <td style="text-align: center">
                                    @if (data.ARReportUser) {
                                        <span style="color: green" class="fa-solid fa-check"></span>
                                    }
                                </td>
                            }
                            @if (moduleIsEnabled("FINReport")) {
                                <td style="text-align: center">
                                    @if (data.FINReportUser) {
                                        <span style="color: green" class="fa-solid fa-check"></span>
                                    }
                                </td>
                            }
                            @if (showDeleted) {
                                <td style="text-align: center">
                                    @if (data.Deleted) {
                                        <span style="color: red" class="fa-solid fa-check"></span>
                                    }
                                </td>
                            }
                            <td style="text-align: center">
                                <button
                                    nz-button
                                    [routerLink]="['/configure/useredit']"
                                    [queryParams]="{id: data.UserID}"
                                    class="btn btn-default">
                                    <span class="fa-solid fa-pen-to-square"></span>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            }
            <!-- end normal user search results -->
            <!-- begin deleted user search results -->
            @if (showDeleted) {
                <thead style="border: 1px solid black">
                    <tr>
                        @for (column of deletedColumns; track column) {
                            @if (column.enabled) {
                                <th
                                    [nzShowSort]="column.compare"
                                    [nzSortFn]="column.compare"
                                    [nzColumnKey]="column.fieldName"
                                    [nzSortOrder]="getSortOrder(column.fieldName)">
                                    {{ column.title }}
                                </th>
                            }
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (data of users.Data; track data.UserID) {
                        <tr>
                            <td style="text-align: center" class="scrollable-cell">{{ data.UserName }}</td>
                            <td style="text-align: center" class="scrollable-cell">{{ data.Email }}</td>
                            <td style="text-align: center">
                                <button nz-button class="btn btn-default" (click)="restoreUser(data.UserID)">
                                    <span class="fa-solid fa-arrows-rotate"></span>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            }
            <!-- begin deleted user search results -->
        </nz-table>
        <ng-template #totalTemplate let-total>
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </ng-template>
    </div>
</div>
<ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
<ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
